import { render, staticRenderFns } from "./detailPlanoCommunication.vue?vue&type=template&id=37e8473a"
import script from "./detailPlanoCommunication.vue?vue&type=script&lang=js"
export * from "./detailPlanoCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports